import { render } from "./Spinner.vue?vue&type=template&id=52df3e92&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=52df3e92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52df3e92"

export default script